








import {Component, Vue, Prop, Mixins} from 'vue-property-decorator';
import {Mixin} from "@/mixins";

@Component({
    name: "NiceCheckbox",
})
export default class NiceCheckbox extends Mixins(Mixin) {
    @Prop()
    value!: boolean;

    @Prop({default: false})
    error!: boolean;

    change()
    {
        this.$emit('input', !this.value);
    }
}
